import React from 'react';
import { upperFirst } from 'lodash';
import { Attribute } from '~/types/models';
import { useRelativeDate } from '~/react-hooks/use-date';
import { attributeTypes } from '~/App/Components/Attributes/AttributeTypes';
import Formatter, {
  getAttributeType,
  getIconComponentForType,
} from '~/App/Components/Attributes/Formatter';

function getDateFormatter() {
  return (value?: string | number) => {
    const relative = useRelativeDate(value);

    if (relative) {
      return upperFirst(relative);
    }
  };
}

type FormatterWithTimezoneProps = Pick<Attribute, 'type'> &
  Pick<Attribute, 'value'>;

const FormatterWithTimezone = (props: FormatterWithTimezoneProps) => (
  <Formatter
    {...props}
    formatters={{
      [attributeTypes.DATE]: getDateFormatter(),
    }}
  />
);

const getAttributeSymbol = (type: string) => {
  const Icon = getIconComponentForType(type);

  return <Icon className='h-4 !w-4' />;
};

interface AttributeListItemProps {
  attribute: Attribute;
}

export default function AttributeListItem({
  attribute,
}: AttributeListItemProps) {
  const attributeType =
    attribute.type ?? getAttributeType(attribute.name, attribute.value);

  return (
    <div className='flex flex-wrap'>
      <div className='w-1/4 min-w-fit v2-text-neutral-500 pr-2 flex'>
        <div className='mr-3'>{getAttributeSymbol(attributeType)}</div>
        <div>{attribute.name}</div>
      </div>
      <div className='v2-text-neutral-900 min-w-[100px]'>
        <FormatterWithTimezone type={attributeType} value={attribute.value} />
      </div>
    </div>
  );
}
